import { faCheckCircle, faTriangleExclamation, faUpload } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, Flex, Text, TextButton } from '@modusign/design-system';

import LoadingStatus from '@libs/loading-status';

interface MinimizedDocumentUploadModalProps {
  status: LoadingStatus;
  succeededDocumentCount: number;
  failedDocumentCount: number;
  remainedDocumentCount: number;
  onMaximize: () => void;
}
export default function DocumentUploadModalSnackBar({
  onMaximize,
  status,
  succeededDocumentCount,
  failedDocumentCount,
  remainedDocumentCount,
}: MinimizedDocumentUploadModalProps) {
  let description = '';

  switch (status) {
    case LoadingStatus.PENDING:
      description = `${remainedDocumentCount}개 계약 등록 중`;
      if (failedDocumentCount > 0) {
        description += ` (${failedDocumentCount}개 실패)`;
      }
      break;

    case LoadingStatus.SUCCEEDED:
      if (failedDocumentCount > 0) {
        description = ` 계약 등록 완료 (${failedDocumentCount}개 실패)`;
      } else {
        description = `${succeededDocumentCount}개 계약 등록 완료`;
      }
      break;
    default:
  }

  return (
    <Box maxWidth="xs" p={4} width="min(450px, 100vw)">
      <Flex
        alignItems="center"
        bg="notificationBackgroundSecondaryUltraDark"
        borderRadius="4px"
        boxShadow="0px 4px 10px rgba(0, 0, 0, 0.25)"
        justifyContent="space-between"
        pl={5}
        pr={4}
        py={5}
      >
        <Flex alignItems="center">
          <StatusIcon
            status={
              status === LoadingStatus.SUCCEEDED && failedDocumentCount > 0
                ? LoadingStatus.FAILED
                : status
            }
          />
          <Text color="textNeutralLightest" fontWeight="medium" ml={4}>
            {description}
          </Text>
        </Flex>
        <TextButton
          sx={{
            color: 'textNeutralUltraLight',
            '&:hover': {
              color: 'textNeutralLightest',
            },
          }}
          onClick={onMaximize}
        >
          자세히 보기
        </TextButton>
      </Flex>
    </Box>
  );
}

function StatusIcon({ status }: { status: LoadingStatus }) {
  switch (status) {
    case LoadingStatus.PENDING:
      return (
        <Box color="iconNeutralLightest" fontSize="18px">
          <FontAwesomeIcon icon={faUpload} />
        </Box>
      );
    case LoadingStatus.SUCCEEDED:
      return (
        <Box color="iconPositiveBase" fontSize="18px">
          <FontAwesomeIcon icon={faCheckCircle} />
        </Box>
      );
    case LoadingStatus.FAILED:
      return (
        <Box color="iconNegativeBase" fontSize="18px">
          <FontAwesomeIcon icon={faTriangleExclamation} />
        </Box>
      );
    default:
      return null;
  }
}
